import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { CardSearchInput } from '../../cardMenu';
import { useFullPlaylist } from '../../savedItems';

const useFilteredPlaylistItems = (playlist, searchText) => {
  if (!playlist) return null;
  if (!searchText || !searchText.length) return playlist.items;
  return playlist.items.filter(({
    name
  }) => name.toLowerCase().includes(searchText));
};

const PlaylistItemsSearch = ({
  playlistId,
  render
}) => {
  const [searchText, setSearchText] = useState('');
  const {
    playlist,
    playlistLoading
  } = useFullPlaylist(playlistId);
  const displayedItems = useFilteredPlaylistItems(playlist, searchText);
  if (playlistLoading) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardSearchInput, {
      onSearchChange: text => setSearchText(text),
      placeholder: "learningCenter.cardMenu.searchItemsPlaceholder"
    }), render(playlist, displayedItems)]
  });
};

export default PlaylistItemsSearch;